import { render, staticRenderFns } from "./ComplaintInfoCard.vue?vue&type=template&id=7b551a44"
import script from "./ComplaintInfoCard.vue?vue&type=script&lang=ts"
export * from "./ComplaintInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports